import { createFileRoute } from "@tanstack/react-router";

import WritersCreateUpdate from "@/features/writers/WritersCreateUpdate";

export const Route = createFileRoute("/_auth/writers/update/$id")({
  component: () => <WritersCreateUpdate key="update" />,
});
